import type { FunctionComponent } from "react";
import { Button } from "../../ui/button";
import { useToast } from "../../../hooks/use-toast";
import { handleHttpError } from "../../../utils/utils";
import Spinner from "../../spinner.components";
import type { ISocial } from "../../../types/models/social.models.types";
import { useRemoveFixedPayoutAdminHttp } from "../../../hooks/http/admin/socials/remove-fixed-payout.admin.http";

type AppProps = {
	removeById: (id: string) => void;
	social: ISocial;
	className?: string;
};

export const RemoveFromFixedPayout: FunctionComponent<AppProps> = ({
	social,
	removeById,
	className,
}) => {
	const { execute: removeFixedPayoutHttp, fetching: removingFixedPayout } =
		useRemoveFixedPayoutAdminHttp();

	const { toast } = useToast();

	const handleRemoveFromFixedPayout = async () => {
		const response = await removeFixedPayoutHttp({
			body: null,
			pathParams: { socialId: social.id },
		});
		if (!response.success) {
			return handleHttpError(response, toast);
		}
		removeById(social.id);
	};

	return (
		<Button
			disabled={removingFixedPayout}
			onClick={handleRemoveFromFixedPayout}
			className={`border-rejectbuttonborder w-24 h-10 bg-rejectbuttonbg border font-semibold text-rejectbuttontext tracking-wider ${className}`}
		>
			{removingFixedPayout ? <Spinner width={15} /> : "remove"}
		</Button>
	);
};
